import { createSelector } from 'reselect';

import { getCompany } from './company.selectors';

export const selectMsr = createSelector(getCompany, ({ msr }) => msr);

export const selectMsrValues = createSelector(selectMsr, Object.values);
